<template>
  <div
    class="Overlay Overlay-sup"
    data-action="close-modal"
    @click.self="closeModal"
  >
    <div class="ModalBox ModalBox--central ModalBox--20vw Modal--filters sup2">
      <div class="ModalBox-header d-flex justify-content-between align-items-center position-absolute p-3">
        <div
          class="Tit Tit--modal position-absolute w-100"
          v-t="{ path: 'benefits_time_restrictions_configuration_modal' }"
        ></div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Close"
          >
            <use xlink:href="#close-icon" />
          </svg>
        </div>
      </div>
      <div class="ModalBox-container position-relative pl-4 pr-4 pt-4 mt-5 pb-3">
        <div class="d-flex flex-column">
          <span v-t="{path:'benefits_configuration_settings_time_restrictions'}"></span>
          <span
            class="p--tip my-1"
            v-t="{path:'benefits_configurations_settings_time_restrictions_warning'}"
          ></span>
          <div class="mt-3 d-flex flex-row justify-content-between p-3">
            <div class="row w-100 d-flex justify-content-between">
              <div class="d-flex flex-column col-md-6">
                <span
                  class="my-2"
                  v-t="{path:'benefits_configurations_time_restrictions_weekdays'}"
                ></span>
                <ul class="Fuell-List ml-3">
                  <li
                    class="Fuell-List--item my-1"
                    v-for="(weekday, index) in timeRestrictions"
                    :key="weekday.id"
                  >
                    <div class="row d-flex justify-content-between px-2">
                      <div class="d-flex align-items-center col-12-col-md-3">
                        <input-checkbox
                          :id="`weekday-${weekday.id}-restriction-checkbox`"
                          :value.sync="weekday.activated"
                          @click="setField(`timeRestrictions[${index}].activated`, $event)"
                        ></input-checkbox>
                        <label class="ml-2 mt-1">{{$t(`day_of_week_${weekday.id}`)}}</label>

                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="d-flex flex-column  col-md-6">
                <span
                  class="my-2"
                  v-t="{path:'benefits_configurations_time_restrictions_restricted_time'}"
                ></span>
                <div class="my-2">
                  <label class="label form--label">{{$t('benefits_configuration_settings_time_restrictions_from_label').toUpperCase()}}</label>
                  <time-selector-input
                    :hours.sync="from.hours"
                    :classList="invalidFromClass"
                    @changeHours="setTimeRestriction('from', 'hours', $event)"
                    @changeMinutes="setTimeRestriction('from', 'minutes', $event)"
                    @resetTime="resetTimeRestrictions('from')"
                    :minutes.sync="from.minutes"
                  ></time-selector-input>
                  <small
                    class="text-danger"
                    v-if="!validFromTime"
                    v-t="{path:'benefits_configuration_time_from_after_to'}"
                  ></small>
                </div>
                <div class="my-2">
                  <label class="label form--label">{{$t('benefits_configuration_settings_time_restrictions_to_label').toUpperCase()}}</label>
                  <time-selector-input
                    :hours.sync="to.hours"
                    :minutes.sync="to.minutes"
                    :classList="invalidToClass"
                    @changeHours="setTimeRestriction('to', 'hours', $event)"
                    @changeMinutes="setTimeRestriction('to', 'minutes', $event)"
                    @resetTime="resetTimeRestrictions('to')"
                  ></time-selector-input>
                  <small
                    class="text-danger"
                    v-if="!validToTime"
                    v-t="{path:'benefits_configuration_time_to_before_from'}"
                  ></small>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-3 d-flex justify-content-center">
        <button
          type="button"
          @click="closeModal"
          class="Fuell-Button red mx-2"
        >
          <span
            class="Fuell-Button--label"
            v-t="{ path: 'ACTION_CANCEL' }"
          ></span>
        </button>
        <button
          type="button"
          class="Fuell-Button blue mx-2"
          :disabled="!canBeSubmitted"
          @click="setTimeRestrictionConfiguration"
        >
          <span
            class="Fuell-Button--label"
            v-t="{ path: 'ACTION_SAVE' }"
          ></span>
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import InputCheckbox from '@/components/Commons/Forms/InputCheckbox'
import TimeSelectorInput from '@/components/Commons/Forms/TimeSelectorInput'
import companyApi from '@/modules/company/_api'

export default {
  name: 'BenefitsTimeRestrictionsConfigurationModal',
  mixins: [_modalHandlerMixin],
  components: {
    InputCheckbox,
    TimeSelectorInput
  },
  computed: {
    isDirty () {
      const fromCurrentConfig = JSON.stringify(this.from)
      const toCurrentConfig = JSON.stringify(this.to)
      const timeRestrictionsCurrentConfig = JSON.stringify(this.timeRestrictions)

      const hasChangedFromConfig = JSON.stringify(this.originalConfig.from) !== fromCurrentConfig
      const hasChangedToConfig = JSON.stringify(this.originalConfig.to) !== toCurrentConfig
      const hasChangedTimeRestrictions = JSON.stringify(this.originalConfig.timeRestrictions) !== timeRestrictionsCurrentConfig

      return hasChangedFromConfig || hasChangedToConfig || hasChangedTimeRestrictions
    },
    currentCompany () {
      return this.$store.getters['CompanyStore/currentCompany'] || false
    },
    timeRestrictionsConfiguration () {
      return this.currentCompany ? this.currentCompany.configs.find(el => el.code === 'FLEXIBLE_REMUNERATION_DAY_AND_HOUR_LIMITS') : false
    },
    timeRestrictionsOriginalConfig () {
      return this.timeRestrictionsConfiguration.config || false
    },
    fromTime () {
      return this.$moment.utc(`${this.from.hours}:${this.from.minutes}`, 'HH:mm').format()
    },
    toTime () {
      return this.$moment.utc(`${this.to.hours}:${this.to.minutes}`, 'HH:mm').format()
    },
    validFromTime () {
      return this.$moment.utc(this.fromTime).isBefore(this.toTime)
    },
    validToTime () {
      return this.$moment.utc(this.toTime).isAfter(this.fromTime)
    },
    invalidFromClass () {
      return !this.validFromTime ? 'input--error' : ''
    },
    invalidToClass () {
      return !this.validToTime ? 'input--error' : ''
    },
    canBeSubmitted () {
      return this.validFromTime && this.validToTime && this.isDirty
    }
  },
  data () {
    return {
      originalConfig: {
      },
      from: {
        hours: '00',
        minutes: '00'
      },
      to: {
        hours: '23',
        minutes: '59'
      },
      timeRestrictions: [
        {
          id: 0,
          code: 'MONDAY',
          activated: false
        }, {
          id: 1,
          code: 'TUESDAY',
          activated: false
        }, {
          id: 2,
          code: 'WEDNESDAY',
          activated: false
        }, {
          id: 3,
          code: 'THURSDAY',
          activated: false
        }, {
          id: 4,
          code: 'FRIDAY',
          activated: false

        }, {
          id: 5,
          code: 'SATURDAY',
          activated: false
        }, {
          id: 6,
          code: 'SUNDAY',
          activated: false
        }
      ]
    }
  },
  methods: {
    setTimeRestriction (fromOrTo, hoursOrMinutes, value) {
      this[fromOrTo][hoursOrMinutes] = value
    },
    setField (field, value) {
      this[field] = value
    },
    resetTimeRestrictions (fromOrTo) {
      if (fromOrTo === 'from') {
        this.from = { ...this.originalConfig.from }
      } else {
        this.to = { ...this.originalConfig.to }
      }
    },
    async setTimeRestrictionConfiguration () {
      let config = {
        configs: [
          {
            code: 'FLEXIBLE_REMUNERATION_DAY_AND_HOUR_LIMITS',
            config: {
              days: {
                'MONDAY': this.timeRestrictions[0].activated,
                'TUESDAY': this.timeRestrictions[1].activated,
                'WEDNESDAY': this.timeRestrictions[2].activated,
                'THURSDAY': this.timeRestrictions[3].activated,
                'FRIDAY': this.timeRestrictions[4].activated,
                'SATURDAY': this.timeRestrictions[5].activated,
                'SUNDAY': this.timeRestrictions[6].activated
              },
              startHour: `${this.from.hours}:${this.from.minutes}:00`,
              finishHour: `${this.to.hours}:${this.to.minutes}:59`
            }
          }
        ]
      }
      try {
        await companyApi.putOffice(this.currentCompany.id, config)
        await this.$store.dispatch('CompanyStore/fetchCompany', this.currentCompany.id)
        this.$store.dispatch('SnackBars/addSuccess', this.$t('benefits_configuration_time_restrictions_success'), { root: true })
        this.closeModal()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'benefits_configuration_time_restrictions_error' }, { root: true })
      }
    },
    _initialize () {
      if (this.timeRestrictionsConfiguration) {
        let startHour = this.timeRestrictionsConfiguration.config.startHour.split(':')
        let finishHour = this.timeRestrictionsConfiguration.config.finishHour.split(':')
        this.from.hours = startHour[0]
        this.from.minutes = startHour[1]
        this.to.hours = finishHour[0]
        this.to.minutes = finishHour[1]
        this.originalConfig.from = { ...this.from }
        this.originalConfig.to = { ...this.to }
        this.originalConfig.timeRestrictions = []
        Object.keys(this.timeRestrictionsConfiguration.config.days).forEach((el) => {
          let day = this.timeRestrictions.find(day => day.code === el)
          day.activated = this.timeRestrictionsConfiguration.config.days[el]
          this.originalConfig.timeRestrictions.push({ ...day })
        })
      }
    }

  },
  created () {
    this._initialize()
  }
}
</script>

<style lang="scss" scoped>
.Fuell-List {
  list-style-type: none;
  padding-inline-start: 0px;
  &--item {
    margin: 10px 0px;
    padding: 5px 0px;
    border: none;
    &:last-child {
      border: none;
    }
    &-content {
      padding: 15px;
      /* border: 1px solid var(--gray-light); */
      border-right: 1px solid var(--gray-light);
      border-left: 1px solid var(--gray-light);
      border-bottom: 1px solid var(--gray-light);
      -webkit-box-shadow: 0px 10px 10px -1px rgba(0, 0, 0, 0.1);
      box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.1);
      transition: all 0.5s ease-in-out;
    }
  }
}
</style>
